import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import {
    LoanRequest_EuropaceLoanOffersSuccessResponseReceived,
    LoanRequest_EuropaceOffersSyncNewOfferFound,
} from 'cpool-events';
import { z } from 'zod';

const defaultProperties = z.object({
    createdAt: z.coerce.date(),
    loanRequestId: z.string(),
    requestId: z.string(),
});

export const schemaOffersEuropace = LoanRequest_EuropaceLoanOffersSuccessResponseReceived.prototype
    .getSchema()
    .pick({
        incompletenessMessages: true,
        offers: true,
    })
    .merge(
        z.object({
            source: z.literal(LOAN_REQUEST_OFFER_SOURCES.EUROPACE),
        }),
    )
    .merge(defaultProperties);

export const schemaOffersEuropaceSync = z.object({
    offers: z.array(
        LoanRequest_EuropaceOffersSyncNewOfferFound.prototype
            .getSchema()
            .shape.newOffer.merge(z.object({ id: z.string().uuid() })),
    ),
    source: z.literal(LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC),
});
